import React from 'react';
import { Modal, Button, Descriptions, Card, Tag } from 'antd';
import { TruckOutlined } from '@ant-design/icons';
import countryList from 'react-select-country-list';

const FreightDetailsModal = ({ 
  visible, 
  onCancel, 
  selectedFreight, 
  zIndex = 1000 
}) => {
  // 获取国家列表数据
  const countries = countryList();
  const countryOptions = countries.getData();

  const getCountryName = (countryCode) => {
    const country = countryOptions.find(option => option.value === countryCode);
    return country ? country.label : countryCode;
  };

  const renderFreightDetails = (data) => {
    if (!data || typeof data !== 'object') return <div>No freight data available</div>;

    return (
      <div>
        {Object.entries(data).map(([countryCode, countryData]) => (
          <Card 
            key={countryCode} 
            size="small" 
            title={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tag color="blue" style={{ marginRight: 8 }}>{countryCode}</Tag>
                <strong>{getCountryName(countryCode)}</strong>
              </div>
            }
            style={{ marginBottom: 16 }}
            type="inner"
          >
            {countryData && typeof countryData === 'object' ? (
              <div>
                {/* ETA Information */}
                {countryData.eta ? (
                  <div style={{ marginBottom: 12 }}>
                    <Tag color="green">ETA: {countryData.eta} days</Tag>
                  </div>
                ) : (
                  <div style={{ color: '#999', fontStyle: 'italic' }}>No ETA information available</div>
                )}
              </div>
            ) : (
              <div style={{ color: '#999', fontStyle: 'italic' }}>No data available</div>
            )}
          </Card>
        ))}
      </div>
    );
  };

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TruckOutlined style={{ marginRight: 8, color: '#1890ff' }} />
          {selectedFreight?.name}
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button 
          key="close" 
          onClick={onCancel}
        >
          Close
        </Button>
      ]}
      width={800}
      zIndex={zIndex}
    >
      {selectedFreight && (
        <div>
          <Descriptions bordered size="small" style={{ marginBottom: 16 }}>
            <Descriptions.Item label="Channel ID" span={1}>
              {selectedFreight.id}
            </Descriptions.Item>
            <Descriptions.Item label="Channel Name" span={2}>
              {selectedFreight.name}
            </Descriptions.Item>
            <Descriptions.Item label="Created" span={1}>
              {new Date(selectedFreight.created_at).toLocaleString('en-US')}
            </Descriptions.Item>
            <Descriptions.Item label="Last Updated" span={2}>
              {new Date(selectedFreight.updated_at).toLocaleString('en-US')}
            </Descriptions.Item>
          </Descriptions>
          
          <h4 style={{ marginTop: 16, marginBottom: 12 }}>Freight Rates by Region:</h4>
          {renderFreightDetails(selectedFreight.data)}
        </div>
      )}
    </Modal>
  );
};

export default FreightDetailsModal;
